import { LoginBonusKind } from '../../../../../services/exports/Constants';

export default {
  [LoginBonusKind.MobileAppSignupBonus]: {
    toast: 'Glückwunsch! Du hast {{amount}} Cashback erhalten.',
  },
};
